import "../styles/CategoryFilter.css";

const CATEGORIES = [
	{ id: "all", label: "Alle kategorier" },
	{ id: "maskinskade", label: "Maskinskade" },
	{ id: "glasskade", label: "Glasskade" },
	{ id: "parkeringsskade", label: "Parkeringsskade" },
	{ id: "kollisjon", label: "Kollisjon" },
	{ id: "leiebil", label: "Leiebil" },
	{ id: "rettshjelp", label: "Rettshjelp" },
	{ id: "førerOgPassasjerulykke", label: "Fører og passasjerulykke" },
	{ id: "brann", label: "Brann" },
	{ id: "naturskader", label: "Naturskader" },
	{ id: "tyveri", label: "Tyveri" },
	{ id: "hærverk", label: "Hærverk" },
	{ id: "bagasjeOgEiendeler", label: "Bagasje og eiendeler" },
	{ id: "utforkjøring", label: "Utforskjøring" },
	{ id: "feilfylling", label: "Feilfylling" },
	{ id: "veihjelp", label: "Veilhjelp" },
	{ id: "ladekabelOgElbilUtstyr", label: "Ladekabel og elbilutstyr" },
];

interface CategoryFilterProps {
	selectedCategory: string;
	onCategoryChange: (category: string) => void;
	hasDifferencesInCategory?: (category: string) => boolean;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
	selectedCategory,
	onCategoryChange,
	hasDifferencesInCategory,
}) => {
	return (
		<div className="category-filter">
			<h3>Filtrer etter kategori</h3>
			<div className="category-buttons">
				{CATEGORIES.map((category) => (
					<button
						key={category.id}
						type="button"
						className={`category-button ${selectedCategory === category.id ? "selected" : ""} ${
							hasDifferencesInCategory &&
							category.id !== "all" &&
							hasDifferencesInCategory(category.id)
								? "has-differences"
								: ""
						}`}
						onClick={() => onCategoryChange(category.id)}
					>
						{category.label}
						{hasDifferencesInCategory &&
							category.id !== "all" &&
							hasDifferencesInCategory(category.id) && (
								<span
									className="difference-indicator"
									title="Det er forskjeller i denne kategorien"
								>
									!
								</span>
							)}
					</button>
				))}
			</div>
		</div>
	);
};

export default CategoryFilter;
